export const base = {
	production: false,
	showInternal: true,
	functionsRegion: 'northamerica-northeast1',
	/** RTDB path KillSwitchService watches — any change forces a logout + page refresh. */
	killSwitchPath: '/config/killSwitchCem',
	services: {
		vehicles: true,
		metadata: true,
		sectors: true,
		services: true,
		accountStatus: true,
		user: true,
		faq: true,
		profile: true,
		subscription: true,
		parks: true,
		organization: true,
		contract: true,
		accessCode: true
	},
	recaptcha: {
		siteKey: '6Lcqg9QiAAAAAIXPvqEsZNv8hSPrAKEeFrGbfymw',
		disabled: false
	},
	moneris: {
		url: 'https://esqa.moneris.com/HPPtoken/index.php',
		gatewayUrl: 'https://gatewayt.moneris.com',
		mode: 'qa' as const,
		paypage: {
			id: 'M4GQ3tore1',
			key: 'hpXEANG66AJ6'
		},
		vault: {
			id: 'ENU7Ttore1',
			key: 'res4LS4NFBYC'
		}
	},
	settings: {
		menu: [
			{
				id: 'subscription',
				name: 'Informations personnelles',
				description: 'Configurez vos informations personnelles qui seront utilisées par défaut dans votre compte.'
			},
			{ id: 'profile', name: 'Profil du compte', description: 'Configurez vos informations de connexion' },
			{ id: 'vehicles', name: 'Mes véhicules', description: 'Configurez vos véhicules' },
			{ id: 'password', name: 'Mot de passe', description: 'Modifiez le mot de passe de votre compte' },
			{ id: 'email', name: 'Adresse courriel', description: "Modifiez l'adresse courriel de votre compte" },
			{ id: '2fa', name: 'Validation en deux étapes ', description: 'Validation en deux étapes' },
			{
				id: 'cc',
				name: 'Carte de crédit',
				description: 'Mettez à jour les informations de votre carte de crédit'
			}
		]
	},
	scopes: {
		cnmtl: {
			selectSectorText: "Selectionnez l'installation désirée"
		},
		cisssbsl: {
			hideAddressInParkList: true
		},
		artm: {
			hideAddressInParkList: true
		},
		cisssca: {
			hideAddressInParkList: true
		},
		cisssgaspesie: {
			hideAddressInParkList: true,
			selectServiceTitle: "Sélectionnez le port d'attache",
			accessCardText: `Le stationnement sélectionné pourrait nécessiter une carte d'accès pour y accéder`
		},
		cssdm: {
			allowRegistrationDomains: ['spaq.com', 'csdm.qc.ca'],
			showSubmitCardHolder: true,
			acceptPaymentOnApproveText:
				"Je comprends que je pourrai accéder au stationnement seulement lorsque ma demande aura été approuvée, et que je ne serai facturé qu'après avoir utilisé le service.",
			accessCardText: `Le stationnement sélectionné pourrait nécessiter une carte d'accès pour y accéder`
		},
		ramq: {
			denyRegistrationDomains: ['ramq.gouv.qc.ca']
		},
		public: {
			acceptPaymentOnApproveText:
				"Je comprends que je pourrai accéder au stationnement seulement lorsque ma demande aura été approuvée, et que je ne serai facturé qu'après avoir utilisé le service.",
			accessCardText: `Le stationnement sélectionné nécessite une carte d'accès pour y accéder`,
			hideTextNotApplicableLicensePlate: true
		},
		ccsmtl: {
			disableImportOnContractCreate: true,
			accessCardText: `Le stationnement sélectionné pourrait nécessiter une carte d'accès pour y accéder`
		}
	},
	useEmulators: false,
	applicationInsights: {
		connectionString:
			'InstrumentationKey=784d1ec6-d66c-47b4-a6b7-674e09de4a4c;IngestionEndpoint=https://canadaeast-0.in.applicationinsights.azure.com/;LiveEndpoint=https://canadaeast.livediagnostics.monitor.azure.com/;ApplicationId=6870dc2f-1e06-4e0e-b9aa-8f2976b2450e',
		enabled: true
	},
	msal: {
		clientId: '53ad86a9-6ed3-458c-b77c-2e58f55245a0',
		tenantId: '5667713e-ccf5-4f0d-b7ec-3f835f82237f',
		redirectUri: 'https://cem.passerelle.staging.spaq.app/account/contract/create'
	}
};
